import api from './api';

// Helper function to check authentication
const checkAuth = () => {
  const token = localStorage.getItem('token');
  if (!token) {
    throw new Error('Authentication required. Please sign in.');
  }
  return token;
};

/**
 * 범용 Gemini API 쿼리
 * @param {string} prompt - Gemini에게 보낼 프롬프트
 * @param {string} model - 모델 이름 (기본: gemini-pro)
 * @param {number} temperature - 온도 설정 (기본: 0.7)
 * @param {number} maxTokens - 최대 토큰 수 (기본: 2048)
 */
export const queryGemini = async (prompt, model = 'gemini-pro', temperature = 0.7, maxTokens = 2048) => {
  try {
    checkAuth();
    
    const response = await api.post('/api/data_predator/gemini/query/', {
      prompt,
      model,
      temperature,
      max_tokens: maxTokens
    });
    
    return response.data;
  } catch (error) {
    console.error('Failed to query Gemini:', error);
    throw error;
  }
};

/**
 * Gemini를 사용한 주식 검색
 * @param {string} query - 검색어 (종목명 또는 종목 코드)
 * @param {number} limit - 결과 개수 제한 (기본: 10)
 */
export const searchStocksWithGemini = async (query, limit = 10) => {
  try {
    checkAuth();
    
    const response = await api.get('/api/data_predator/gemini/stock-search/', {
      params: {
        query,
        limit
      }
    });
    
    return response.data;
  } catch (error) {
    console.error('Failed to search stocks with Gemini:', error);
    throw error;
  }
};
